import { showDownloadReportModal } from "@actions/modals";
import React from "react";
import { connect } from "react-redux";
import { Button, Input, Form, Modal } from "semantic-ui-react";

const DownloadReportModal = (props) => {
  const { open, filename, onSave } = props.modal;
  const { showDownloadReportModal } = props;
  const onClose = () => showDownloadReportModal(false, "", () => {});

  const onChange = (e, { value }) => {
    showDownloadReportModal(open, value, onSave);
  };

  return (
    <Modal open={open} onClose={onClose} size="small" closeIcon>
      <Modal.Header>Download Report</Modal.Header>
      <Modal.Content className="h-100">
        <Form>
          <Form.Field>
            <label>Enter Report Name:</label>
            <Input icon="file" onChange={onChange} value={filename} />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button negative onClick={onClose}>
          Cancel
        </Button>
        <Button
          positive
          disabled={filename.length < 1}
          onClick={() => onSave(filename).then(onClose)}
        >
          Download
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    modal: state.downloadReportModal,
  };
};

export default connect(mapStateToProps, { showDownloadReportModal })(
  DownloadReportModal,
);
